import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration'; // Make sure to import your configuration
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-common-property',
  templateUrl: './common-property.component.html',
  styleUrls: ['./common-property.component.css']
})
export class CommonPropertyComponent implements OnInit {
  @Input() propertyData: any;
  @Input() isMyProperty: any
  propertyImage: any;
  address: any = [];
  propertyList: any = []; // Assuming you want to store the result of the new API call
  is_modal: any = true
  fromButtonLogin: boolean = false;
  is_fav: any = false
  is_delete_modal: any = false
  socialForm: FormGroup;
  subscriptionInfo: any = null
  propertyDataInfo: any = null
  currentInvoiceId: any = null
  currentPropertyId = null;
  developerMobile: string = '';
developerEmail: string = '';
developerWhatsappNumber: string = '';

  constructor(public shared: SharedService, private apiService: ApiServiceService, private fb: FormBuilder,
  ) {
    this.socialForm = this.fb.group({
      contact: ['', Validators.required],
      email: ['', Validators.required],
      whatsapp_number: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    console.log("propertyData", this.propertyData)
    this.propertyData.no_of_bedrooms = this.shared.getIntValue(this.propertyData.no_of_bedrooms);
    this.propertyData.no_of_bathrooms = this.shared.getIntValue(this.propertyData.no_of_bathrooms);
    this.propertyData.plot_area = this.shared.getIntValue(this.propertyData.plot_area);
    // Your existing initialization logic
    // this.isFavP()
    if (this.propertyData && this.propertyData.PropertyToPropertyMediaData) {
      for (let i of this.propertyData.PropertyToPropertyMediaData) {
        if (i.category_type == 1) {
          this.propertyImage = i.images.split(",")[0]
        }
      }
    }
     this.developerMobile = this.propertyData?.PropertyToDeveloper?.developer_mobile || '';
    this.developerEmail = this.propertyData?.PropertyToDeveloper?.developer_email || '';
    this.developerWhatsappNumber = this.propertyData?.PropertyToDeveloper?.developer_whatsapp_no || '';
    // this.propertyImage
  }
async onPopup(type: 'call' | 'mail' | 'whatsapp', propertyId: number, event: Event) {
  event.stopPropagation(); // <-- this stops redirectProperty from firing

  if (!this.shared.isUserLoggedIn) {
    this.shared.fromButtonLogin = true;
    return;
  }

  try {
    const res: any = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_PROPERTY_CONTACT, {
      property_id: propertyId
    });

    if (res && !res.error && res.data) {
      const contact = res.data;

      if (type === 'call' && contact.mobile) {
        window.location.href = `tel:${contact.mobile}`;
      }

      if (type === 'mail' && contact.email) {
        window.location.href = `mailto:${contact.email}`;
      }

      if (type === 'whatsapp') {
        const phone = contact.mobile;
        if (phone) window.open(`https://wa.me/${phone}`, '_blank');
      }
    }
  } catch (error) {
    console.error("Error fetching contact details:", error);
  }
}


  

  async checkAccessToViewProperty() {
    if(this.shared.isUserLoggedIn) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CAN_VIEW_PROPERTY, {
        property_id: this.currentPropertyId
      });
      if (res && !res.error && res.data) {
        if (res.data.subscriptionData) {
          this.subscriptionInfo = res.data.subscriptionData;
        }
        if (res.data.proeprtyData) {
          this.propertyDataInfo = res.data.proeprtyData
        }
        // this.subscriptionMessage = res.message;
        // this.currentInvoiceId = res.data.invoice_id
      }
    } else {
      this.subscriptionInfo = {
        hasSubscription: false
      }
    }
  }

  redirectProperty() {
    window.location.href = "/view-property/" + this.propertyData.id + '/' + this.shared.generateUrlSlug(this.propertyData.property_name);
  }

  async isFavP() {
    if (this.shared.isUserLoggedIn) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CHECK_FAVOURITE_PROPERTY, {
        "property_id": this.propertyData.id
      });
      if (res && !res.error) {
        if (res.data && res.data.length > 0) {
          this.is_fav = true
        } else {
          this.is_fav = false
        }
      }
    } else {
      this.is_fav = false
    }
  }


  async favouriteProperty() {
    if (!this.shared.isUserLoggedIn) {
      this.fromButtonLogin = true;
    } else {
      let is_favourite = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.FAVOURITE_PROPERTY, {
        "property_id": this.propertyData.id,
        is_favourite
      });
      if (res && !res.error) {
        this.is_fav = true
      }
    }
  }

  async onUnfavouriteProperty() {
    if (!this.shared.isUserLoggedIn) {
      this.fromButtonLogin = true;
    } else {
      let is_favourite = false;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.FAVOURITE_PROPERTY, {
        "property_id": this.propertyData.id,
        is_favourite
      });
      if (res && !res.error) {
        this.is_fav = false
      }
    }
  }

  getSubscriptionUrl() {
    return this.propertyData.selling_type == 1
      ? 'subscription-buyer-plan'
      : 'subscription-tenant-plan';
  }

  closeModal() {
    this.currentPropertyId = null;
    $('#socialModal').modal('hide');
  }

  async onCall(data: any) {
    this.currentPropertyId = null;
    setTimeout(() => {
      this.currentPropertyId = data.id;
      setTimeout(async () => {
        await this.checkAccessToViewProperty()
        $('#socialModal').modal('show');
      });
    });
  }
  checkLogin(event: MouseEvent) {
  if (!this.shared.isUserLoggedIn) {
    event.preventDefault();
    this.shared.fromButtonLogin = true;
  }
}


  async onMail(data: any) {
    this.currentPropertyId = data.id
    $('#socialModal').modal('show');
    // if(!this.shared.isUserLoggedIn){
    // this.fromButtonLogin = true;
    // }else{
    //   document.location.href = "mailto:" + mail;
    // }
  }

  async onWp(data: any) {
    console.log("id::", data.id)
    this.currentPropertyId = data.id
    $('#socialModal').modal('show');
    // if(!this.shared.isUserLoggedIn){
    // this.fromButtonLogin = true;
    // }else{
    //   // window.location.href = "https://api.whatsapp.com/send?phone=" + phone;
    //   let url = "https://api.whatsapp.com/send?phone=" + phone;
    //   window.open(url, "_blank");
    // }
  }

  async onSave() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_CONTACTED_PROPERTY, {
      invoice_id: this.currentInvoiceId,
      property_id: this.currentPropertyId,
      // contact: this.socialForm.value.contact,
      // email: this.socialForm.value.email,
      // whatsapp_number: this.socialForm.value.whatsapp_number,
    })
    if (res && !res.error) {
      // setTimeout(() => {
      //   $('#socialModal').modal('hide');
      // });
      // window.location.reload();
    }
  }

  onClose(e: any) {
    this.fromButtonLogin = false;
  }

  onEdit() {
    window.location.href = '/update-property/' + this.propertyData.id
  }

  onDelete() {
    this.is_delete_modal = true
  }

  closeDeleteModal() {
    this.is_delete_modal = false
  }

  onURL(data, type: any) {
    if (type == "phone") {
      document.location.href = "tel:+" + data.PropertyToUserData.phone;
    } else if (type == 'email') {
      document.location.href = "mailto:" + data.PropertyToUserData.email;
    } else {
      let phone = data.PropertyToUserData.whatsapp_no ? data.PropertyToUserData.whatsapp_no : data.PropertyToUserData.phone
      let phone_no = 971 + phone
      let url = "https://api.whatsapp.com/send?phone=" + phone_no;
      window.open(url, "_blank");
    }
  }

  async onSubmit() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.DELETE_PROPERTY, {
      "property_id": this.propertyData.id,
    });
    if (res && !res.error) {
      this.is_delete_modal = true
      window.location.reload();
    }
  }
}
